import React from 'react';

import styles from './styles.module.scss';

const ColumnContainer = ({
  disclaimer,
  title,
  titleDescription,
  smallIcon,
  headerRight,
  children
}) => {
  return (
    <div className={styles.column}>
      <div className={styles.titleContainer}>
        {smallIcon}
        <h3 className={styles.columnTitle}>
          {disclaimer && (
            <span className={styles.disclaimer}>{disclaimer}</span>
          )}
          {title || ''}
          <span className={styles.titleBold}>{titleDescription || ''}</span>
        </h3>
        {headerRight && (
          <div className={styles.headerRightAction}>{headerRight}</div>
        )}
      </div>
      <div className={styles.cardWrapper}>
        <div className={styles.card}>{children}</div>
      </div>
    </div>
  );
};

export default ColumnContainer;
